import { render, staticRenderFns } from "./PrepareForSelfieSvg.vue?vue&type=template&id=0f3e362e&"
import script from "./PrepareForSelfieSvg.vue?vue&type=script&lang=ts&"
export * from "./PrepareForSelfieSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports